module.exports = __webpack_public_path__ + "static/img/iconfont.4c836f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont_ali/iconfont.svg?t=1582110905786
// module id = 1904
// module chunks = 115